import { DomainsChipDownContainer } from "@similarweb/ui-components";
import { ListItemWebsite } from "@similarweb/ui-components";
import type { FC } from "react";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

interface IDomainMD {
    name: string;
    color: string;
    icon: string;
    image: string;
    smallIcon: boolean;
}
type IDomainsMD = Array<IDomainMD>;

interface IDomainsDropdown {
    domainsMD: IDomainsMD;
    disablesDomain: string;
    selectedDomainText: string;
    onClick: (selectedDomain: string) => void;
    onOpen: VoidFunction;
}

const Container = styled.div`
    flex-grow: 0;
`;

const Fade = styled.div`
    color: ${colorsPalettes.carbon[100]};
    cursor: not-allowed;
`;

const renderDomainItems = (domainsMD: IDomainsMD, disablesDomain) => {
    return domainsMD.map(({ name, icon }, index) => {
        const isDisabled = name === disablesDomain;
        return (
            <ListItemWebsite
                key={index}
                text={isDisabled ? null : name}
                img={icon}
                customRenderData={isDisabled ? <Fade>{name}</Fade> : null}
            />
        );
    });
};

export const DomainsDropdown: FC<IDomainsDropdown> = (props) => {
    const t = useTranslation();
    const { domainsMD, disablesDomain, selectedDomainText, onClick, onOpen } = props;
    return (
        <Container onClick={onOpen}>
            <DomainsChipDownContainer
                width={200}
                noResultsMessage={t("dropdown.no.results")}
                onClick={({ text }) => {
                    if (!text) {return;}
                    onClick(text);
                }}
                selectedDomainText={selectedDomainText}
                selectedDomainIcon={domainsMD.find(({ name }) => name === selectedDomainText).icon}
            >
                {renderDomainItems(domainsMD, disablesDomain)}
            </DomainsChipDownContainer>
        </Container>
    );
};
